export default "__VITE_ASSET__Du4ixtC9__"